import { render, staticRenderFns } from "./carousel-slide.vue?vue&type=template&id=07bb33b7"
import script from "./carousel-slide.vue?vue&type=script&lang=js"
export * from "./carousel-slide.vue?vue&type=script&lang=js"
import style0 from "./carousel-slide.vue?vue&type=style&index=0&id=07bb33b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports